import * as linkify from 'linkifyjs';
import linkifyElement from 'linkifyjs/element';

var comments = document.querySelectorAll('.comment')
for(var i=0; i<comments.length; i++) {
  linkifyElement(comments[i])
}
